import { render } from "./WaitTeacher.vue?vue&type=template&id=53dc6c5f&scoped=true"
import script from "./WaitTeacher.vue?vue&type=script&lang=js"
export * from "./WaitTeacher.vue?vue&type=script&lang=js"

import "./WaitTeacher.vue?vue&type=style&index=0&id=53dc6c5f&scoped=true&lang=css"
import "./WaitTeacher.vue?vue&type=style&index=1&id=53dc6c5f&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53dc6c5f"]])

export default __exports__